import { EventHandler } from './types';
import { NgApiClient } from '@src/api/ngApiClient';
import { SSEConfig } from './config';
import { SSEEventProcessor } from './handler';
import { SSEConnectionManager } from './connectionManager';

export class SSEService {
  private connectionManager: SSEConnectionManager;

  constructor(handlers: EventHandler[], client: NgApiClient) {
    const config = new SSEConfig(client);
    const handler = new SSEEventProcessor(handlers);
    this.connectionManager = new SSEConnectionManager(config, handler);
    this.connectionManager.connect();
  }

  public close(): void {
    this.connectionManager.close();
  }
}
